export class Baidumap {
  constructor(difference) {
    this.styleId = 1
    this.width = 600
    this.height = 550
    this.top = 20
    this.left = 20
    this.innerElement = "cxBaidumap"
    this.color = "rgba(0,0,0,1)"
    this.textIsThemeColor = false
    this.background = []
    this.bgColor = "rgb(255, 255, 255)"
    this.imgSrc = ""
    this.bgType = "自定义"
    this.bgColorIsThemeColor = false
    this.opacity = 100
    this.borderTypeFlag = 2 //圆角的类型 分为1四个角可以单独设置 2四个角一致
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderColor = "#E9E9E9"
    this.borderWidth = 1
    this.borderStyle = "solid" // solid, dashed, dotted
    this.borderIsThemeColor = false
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    this.paddingTypeFlag = 1
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.content = ""

    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
